import { AttachmentType, ShareMessageContentFragment } from "~/__generated__/graphql"
import { UserAvatar } from "~/ui/user-avatar"
import { BadgeSize } from "~/ui/user-avatar"
import MessageHeader from "../message-header"
import { MessageAttachments } from "./message-attachments"
import { FormattedAppText } from "~/ui/formatted-app-text"
import { AppText } from "~/ui/app-text"

interface QuotedMessageProps {
  quotedMessage: ShareMessageContentFragment
}

const SUPPORTED_QUOTED_ATTACHMENT_TYPES = [
  AttachmentType.Image,
  AttachmentType.Giphy,
  AttachmentType.Video,
]

export const QuotedMessage: React.FC<QuotedMessageProps> = ({ quotedMessage }) => {
  const user = quotedMessage.user
  const displayName = user?.displayOrUsername || "User"
  const hasAttachments = quotedMessage.attachments?.length > 0
  const supportedQuotedAttachment = SUPPORTED_QUOTED_ATTACHMENT_TYPES.includes(
    quotedMessage.attachments?.[0]?.attachmentType
  )
  return (
    <div className="flex w-fit flex-row justify-between gap-4 rounded-md bg-white/20 p-4">
      <div className="flex flex-col gap-2">
        <div className="flex w-fit flex-row items-center gap-2">
          <UserAvatar avatarUrl={user?.avatarUrl} displayName={displayName} size="xsm" />
          <MessageHeader
            showVerified={user?.verifiedAccount}
            displayName={displayName}
            badgeSize={BadgeSize.md}
            textVariant="body3-medium"
          />
        </div>
        {quotedMessage?.textContent && (
          <FormattedAppText
            text={quotedMessage.textContent}
            variant="body3-medium"
            className={hasAttachments ? "line-clamp-2" : "line-clamp-10"}
          />
        )}
        {hasAttachments && !supportedQuotedAttachment && (
          <AppText variant="body3-medium">Shared an attachment</AppText>
        )}
      </div>
      {hasAttachments && supportedQuotedAttachment && (
        <div className="flex max-w-[48px] items-center justify-center">
          <MessageAttachments attachments={quotedMessage.attachments} className="rounded-xs" />
        </div>
      )}
    </div>
  )
}
